import type { ReactNode } from "react";

interface LunchActionButtonProps {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  danger?: boolean;
  disabled?: boolean;
}

/** Бутон в реда с действия на обедно меню (40px, ghost; опасното е ghost-danger). */
export const LunchActionButton = ({
  icon,
  label,
  onClick,
  danger = false,
  disabled = false,
}: LunchActionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`inline-flex h-10 shrink-0 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[10px] border px-3.5 text-[14px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-45 ${
      danger
        ? "border-pos-danger-brd bg-pos-danger-bg text-pos-danger-ink hover:bg-pos-disc-bg"
        : "border-pos-ctl bg-pos-card text-pos-ink2 hover:bg-pos-panel"
    }`}
  >
    {icon}
    {label}
  </button>
);
